module.exports = __webpack_public_path__ + "img/fmk-stall.db9c4d1e.jpg";